import React, { useState } from "react";
import { secondaryButtonCls } from "../../../components/ui-components/buttonStyles";
import UserSearchInput from "../../../components/form-components/UserSearchInput";
import { usePatchMutation } from "../hooks";

// Assign-owner control: "Assign to me" (server resolves @me) or pick a user.
export default function OwnerAssignMenu({ id, ownerName, disabled }) {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState(null);
  const patch = usePatchMutation(id);
  const assign = (ownerUserId) => {
    patch.mutate({ ownerUserId });
    setOpen(false);
  };
  return (
    <div className="relative">
      <button type="button" className={secondaryButtonCls} disabled={disabled} onClick={() => setOpen((o) => !o)}>
        {ownerName ? `Owner: ${ownerName}` : "Assign owner"}
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-1 w-72 rounded-card border border-card-bd bg-card p-3 shadow-sm" style={{ width: 288 }}>
          <button type="button" className="mb-2 w-full rounded-ctrl bg-primary px-3 py-1.5 text-[13px] font-medium text-white" onClick={() => assign("@me")}>
            Assign to me
          </button>
          <div className="mb-1 text-[11px] uppercase tracking-wide text-text-3">or pick a user</div>
          <UserSearchInput value={picked} onChange={(u) => { setPicked(u); assign(u.user_id); }} />
        </div>
      )}
    </div>
  );
}
